// extracted by mini-css-extract-plugin
export default {"p_content":"_124aad0a22"};